<template>
    <div class="payroll-mobile">
        <template v-if="$atl_company_package_title != 'Provident Fund Only'">
            <!-- Abdullah responsive added mx-3  -->
            <div class="row no-gutters py-2 mb-3 mx-3 custom-mobile-left-side-alignment-margin custom-mobile-padding-left-side-half">
                <div class="col-md-10 col-sm-12">
                    <h4 class="atlhr-dashboard-title mt-10">
                        Pay <span class="black-title">Slips</span>
                        <span>
                            <a v-bind:href="$api_url">Dashboard</a>
                            / Payroll / Pay Slips
                        </span>
                    </h4>
                </div>
            </div>
        </template>
        <template v-else>
            <!-- Abdullah responsive added mx-3  -->
            <div class="row no-gutters py-2 mb-3 border-bottom mx-3 ">
                <div class="col-sm-6 pr-3 ">
                    <h4 class="atlhr-dashboard-title mt-10">
                        PF Slips
                        <span>
                            <a v-bind:href="$api_url">Dashboard</a>
                            / PF Slips
                        </span>
                    </h4>
                </div>
            </div>
        </template>


        <!-- Abdullah responsive added mx-3  -->
        <b-overlay rounded="sm" class="mx-3">
            <b-card no-body class="border-0 bg-transparent no-shadow employee-tab-bg">
                <div class="d-inline-block w-100">
                    <div class="row pt-4">
                        <div class="col-md-3 custom-mobile-left-side-alignment custom-mobile-padding-left-side-half custom-mobile-padding-right-zero">
                            <div class="clearfix company-form-container h-100 p-3 payslip-list-dropdown custom-mobile-margin-right-side-zero">

                                <b-form-select v-model="fiscals" class="mb-3 fiscal-select" :options="options"
                                    v-on:change="filterFiscalYear(fiscals)">
                                    <b-form-select-option :options="options" size="sm" :value='null'>Select Fiscal
                                        Year</b-form-select-option>
                                    <b-form-select-option v-for="(fiscal_year, index) in fiscal_years" :key="index"
                                        :value="fiscal_year.fiscal_year">
                                        {{ fiscal_year.fiscal_year }}
                                    </b-form-select-option>
                                </b-form-select>

                                <b-form-select v-model="selected_month_id" v-on:change="handleMonthSelection">
                                    <b-form-select-option :value="null">Select Payslip Month</b-form-select-option>
                                    <b-form-select-option v-for="(payslip_month, index) in payslip_months" :key="index"
                                        :value="payslip_month.key">
                                        {{ payslip_month.text }}
                                    </b-form-select-option>
                                </b-form-select>

                            </div>
                        </div>

                        <div class="col-md-9 custom-mobile-left-side-alignment custom-mobile-padding-left-side-half custom-mobile-padding-right-zero" v-if="selected_payslip.id > 0">
                            <div class="clearfix company-form-container h-100 p-3 custom-mobile-margin-right-side-zero">
                                <template v-if="$atl_company_package_title != 'Provident Fund Only'">
                                    <EmployeepayslipdetailsFront :dynamic_fields="dynamic_fields"
                                        :pmonth="selected_payslip.month" :pyear="selected_payslip.year"
                                        :payslip="selected_payslip.id" :key='detail_key'
                                        :company="companies[selected_payslip.company_id]"
                                        :payslipname="'Pay Slip for ' + empdata.name + ' - ' + selected_payslip.month + ' ' + selected_payslip.year">
                                    </EmployeepayslipdetailsFront>
                                </template>
                                <template v-else>
                                    <employee-pf-slip-details-front :dynamic_fields="dynamic_fields"
                                        :pmonth="selected_payslip.month" :pyear="selected_payslip.year"
                                        :payslip="selected_payslip.id" :key='detail_key'
                                        :company="companies[selected_payslip.company_id]"
                                        :payslipname="'PF Slip for ' + empdata.name + ' - ' + selected_payslip.month + ' ' + selected_payslip.year"
                                        :emp_etin="empdata.etin" :emp_department="selected_payslip.department"
                                        :emp_jobposition="selected_payslip.jobposition"
                                        :emp_branch="selected_payslip.branch_name"
                                        :emp_code="emp_public_info.employee_code"
                                        :emp_joining="emp_joinng_date"></employee-pf-slip-details-front>
                                </template>
                            </div>
                        </div>
                        <div class="col-md-9 custom-mobile-left-side-alignment custom-mobile-padding-left-side-half custom-mobile-padding-right-zero" v-else>
                            <div class="clearfix company-form-container h-100 p-3 custom-mobile-margin-right-side-zero">
                                <div class='no-data-wrapper'>
                                    No Data found
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </b-card>
        </b-overlay>
    </div>
</template>

<script>

import moment from 'moment';
export default {

    mounted() {
    },

    computed: {
    },

    components: {
        // Employeepayslipdetails
    },
    data() {
        return {

            payslips: [],
            empdata: [],
            companies: [],
            accpayslips: [],
            fiscal_years: [],
            fiscals: null,
            curr_fiscal: [],
            emp_public_info: [],
            selected_payslip: {}, // fix: was [] causing Cannot read properties of null (reading 'id')
            emp_joinng_date: '',
            activeIndex: -1,
            sa: null,
            detail_key: 0,
            dynamic_fields: {},

            //mahmud
            payslip_months: [],
            selected_month_id: null,

            //
        }
    },
    watch: {
        selected_month_id(val) {
            if (val) {
                this.handleMonthSelection(val);
            }
        }
    },
    methods: {

        validateState(ref) {
            if (
                this.veeFields[ref] &&
                (this.veeFields[ref].dirty || this.veeFields[ref].validated)
            ) {
                return !this.veeErrors.has(ref);
            }
            return null;
        },
        getPayslipDynamicFieldData: function (emp_id) {
            axios.get(this.$api_url + '/front/company/payslip-field-settings/get-employee-dynamic-field-data').then(function (response) {
                var ltData = response.data;
                this.dynamic_fields = ltData;

            }.bind(this));
        },
        getpayslips: function (f_year = '') {

            axios.get(this.$api_url + '/front/employeepaysliplists', {
                params: {
                    fiscal_year: f_year
                }
            }).then(function (response) {
                this.payslips = response.data.data.payslips;

                this.payslip_months = []; // Clear previous values

                this.payslips.forEach(element => {
                    this.payslip_months.push({
                        key: element.id,
                        text: element.month + ' ' + element.year
                    });
                });

                this.empdata = response.data.data.employee_info;
                this.companies = response.data.data.companies;
                this.fiscal_years = response.data.data.fiscal_years;
                this.curr_fiscal = response.data.data.fiscal_year;

                if (this.curr_fiscal)
                {
                    this.fiscals = this.curr_fiscal;
                }

                if (this.payslips.length > 0) {

                    let now = new Date();
                    let currentMonth = now.getMonth() + 1;
                    let currentYear = now.getFullYear();

                    let selected = this.payslips[this.payslips.length - 1];
                    let index = this.payslips.indexOf(selected);

                    this.selected_month_id = selected.id; // triggers watcher

                    // fallback safety (if watcher not triggered yet)
                    this.paySlipLoad(selected.id, index);
                }
                else {
                    this.selected_payslip = {}; // fix: was null
                    this.activeIndex = -1;
                }

            }.bind(this));
        },
        handleMonthSelection(payslipId) {
            const index = this.payslips.findIndex(item => item.id === payslipId);

            if (index !== -1) {
                this.paySlipLoad(payslipId, index);
            } else {
                this.selected_payslip = {}; // fix: was null
                this.activeIndex = -1;
            }
        },
        paySlipLoad(card_id, index) {

            const payslip = this.payslips.find(item => item.id === card_id);

            if (payslip) {
                this.$set(this.accpayslips, card_id, 1);

                this.activeIndex = index;
                this.selected_payslip = payslip;

                this.detail_key += 1;
            } else {
                this.selected_payslip = {}; // fix: was null
                this.activeIndex = -1;
            }
        },
        filterFiscalYear(f_year) {
            this.getpayslips(f_year);
        },
        getEmployeePublicInfo: function () {
            if (!this.checkNet()) return false;
            axios.get(this.$api_url + '/front/employee/front/publicinfo', {
                params: {

                }
            }).then(function (response) {
                this.emp_public_info = response.data;
                this.emp_joinng_date = moment(String(response.data.date_of_joining)).format('D MMMM YYYY');
                this.getPayslipDynamicFieldData(this.emp_public_info.employee_id);

            }.bind(this));
        },
        onSubmit: function (e) {
            this.$validator.validateAll().then(result => {
                if (!result) {
                    return;
                }

                e.preventDefault();
                let currentObj = this;

            });
        },

    },
    created: function () {
        this.getpayslips();
        this.getEmployeePublicInfo();
    }
}
</script>
